import { SchemaPageDefinition } from './SchemaDefinition'
import { PageDefinition } from './TypedDefinition'
import { PageNode } from './TypedNode'
import { createPageComponent } from './ViewComponent'
import { PageModel } from './ViewModel'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'
import type { ReactElement } from 'react'

export interface PagePluginProps {
  spinnerElement?: ReactElement
}

export class PagePlugin implements RehajePlugin {
  props: PagePluginProps

  visitors: PluginVisitors
  constructor(props?: PagePluginProps) {
    this.props = { ...props }
    this.visitors = {
      components: {
        Page: createPageComponent(this.props)
      },
      definitions: {
        Page: PageDefinition,
        'Schema.Page': SchemaPageDefinition
      },
      models: {
        Page: PageModel
      },
      nodes: {
        Page: PageNode
      }
    }
  }
}
